export default "__VITE_ASSET__2d230415__"